module.exports = __webpack_public_path__ + "assets/c3f43d57cb3815263cd87188b17fedf0.png";